// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
export const firebaseConfig = {
    apiKey: "AIzaSyB7jg-ieOOqLD20lfN53N_okJ7GJ7B8BeQ",
    authDomain: "animateyouricon.firebaseapp.com",
    projectId: "animateyouricon",
    storageBucket: "animateyouricon.appspot.com",
    messagingSenderId: "35657344896",
    appId: "1:35657344896:web:022b8815d13a0d8ced4365",
    measurementId: "G-MNNLG3T1L7"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
const analytics = getAnalytics(app);
export const storage = getStorage(app);
